// import React from "react";
// import { useNavigate } from "react-router-dom";
// import AnimatedSection from "../../components/AnimatedSection/AnimatedSection";
// import ServiceCard from "../../components/ServiceCard/ServiceCard";
// import ProjectCard from "../../components/ProjectCard/ProjectCard";
// import { SERVICES } from "../../data/services";
// import { PROJECTS } from "../../data/projects";
// import { STATS, WHY_US, IMAGES } from "../../data/constants";
// import "./Home.css";

// function Home() {
//   const navigate = useNavigate();

//   return (
//     <div className="home">

//       {/* ── Hero ── */}
//       <section className="hero">
//         <img src={IMAGES.hero} alt="Industrial concrete floor polishing — SK Associate India" className="hero__bg" />
//         <div className="hero__overlay" />
//         <div className="hero__content">
//           <span className="hero__eyebrow">ONE TIME TREATMENT</span>
//           <h1 className="hero__h1">ADDING LIFE</h1>
//           <h1 className="hero__h1 hero__h1--gold">TO CONCRETE</h1>
//           <p className="hero__sub">
//             SK Associate delivers complete concrete floor polishing &amp; densification solutions for industrial and commercial facilities across India.
//           </p>
//           <div className="hero__btns">
//             <button className="btn-primary" onClick={() => navigate("/services")}>EXPLORE SERVICES</button>
//             <button className="btn-ghost"   onClick={() => navigate("/contact")}>GET FREE QUOTE</button>
//           </div>
//         </div>

//         {/* Stats bar */}
//         <div className="hero__stats">
//           {STATS.map((s) => (
//             <div key={s.label} className="hero__stat">
//               <span className="hero__stat-n">{s.number}</span>
//               <span className="hero__stat-l">{s.label}</span>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* ── About Preview ── */}
//       <section className="section home__about" style={{ background: "#111" }}>
//         <div className="container grid-2">
//           <AnimatedSection>
//             <div className="home__about-img-wrap">
//               <img src={IMAGES.warehouse} alt="SK Associate warehouse floor polishing team" className="home__about-img" />
//               <div className="home__about-badge">
//                 <span className="home__about-badge-n">10+</span>
//                 <span className="home__about-badge-l">YEARS EXPERIENCE</span>
//               </div>
//               <div className="home__about-thumb">
//                 <img src={IMAGES.team} alt="SK Associate expert team" />
//               </div>
//             </div>
//           </AnimatedSection>
//           <AnimatedSection delay={0.2}>
//             <p className="section-label">ABOUT SK ASSOCIATE</p>
//             <h2 className="section-title" style={{ marginBottom: 18 }}>COMPLETE CONCRETE FLOOR SOLUTIONS</h2>
//             <p className="home__body-text">
//               SK Associate is the most valued company in the industry, offering technologically advanced flooring solutions for industrial and commercial facilities across India.
//             </p>
//             <p className="home__body-text" style={{ marginBottom: 30 }}>
//               Our vision is to help improve performance and quality benchmarks with best global practices customized to suit the local environment — integrating and delivering best and durable floors for factories and warehouses.
//             </p>
//             <button className="btn-primary" onClick={() => navigate("/about")}>LEARN MORE ABOUT US</button>
//           </AnimatedSection>
//         </div>
//       </section>

//       {/* ── Full-width Image Band ── */}
//       <div className="home__band">
//         <img src={IMAGES.factory} alt="SK Associate factory floor densification project" className="home__band-img" />
//         <div className="home__band-overlay" />
//         <div className="home__band-text">
//           <AnimatedSection>
//             <p className="section-label" style={{ textAlign: "center" }}>WHY IS DENSIFICATION NECESSARY?</p>
//             <h2 className="home__band-title">
//               Dust particles, rough surfaces &amp; rising maintenance costs — all solved with one treatment.
//             </h2>
//             <button className="btn-primary" onClick={() => navigate("/services")}>SEE HOW WE DO IT</button>
//           </AnimatedSection>
//         </div>
//       </div>

//       {/* ── Services Preview ── */}
//       <section className="section" style={{ background: "#0d0d0d" }}>
//         <div className="container">
//           <AnimatedSection>
//             <div className="home__section-head">
//               <p className="section-label">WHAT WE DO</p>
//               <h2 className="section-title">OUR SERVICES</h2>
//             </div>
//           </AnimatedSection>
//           <div className="grid-auto">
//             {SERVICES.slice(0, 6).map((s, i) => (
//               <AnimatedSection key={s.id} delay={i * 0.07}>
//                 <ServiceCard service={s} />
//               </AnimatedSection>
//             ))}
//           </div>
//           <div style={{ textAlign: "center", marginTop: 44 }}>
//             <button className="btn-outline" onClick={() => navigate("/services")}>VIEW ALL 9 SERVICES</button>
//           </div>
//         </div>
//       </section>

//       {/* ── 4-image gallery strip ── */}
//       <div className="home__gallery-strip">
//         {IMAGES.strip.map((src, i) => (
//           <div key={i} className="home__gallery-strip-cell">
//             <img src={src} alt={`SK Associate industrial floor project ${i + 1}`} />
//           </div>
//         ))}
//       </div>

//       {/* ── Why Choose Us ── */}
//       <section className="section" style={{ background: "#111" }}>
//         <div className="container">
//           <AnimatedSection>
//             <div className="home__section-head">
//               <p className="section-label">OUR ADVANTAGE</p>
//               <h2 className="section-title">WHY CHOOSE SK ASSOCIATE?</h2>
//             </div>
//           </AnimatedSection>
//           <div className="grid-auto">
//             {WHY_US.map((w, i) => (
//               <AnimatedSection key={w.title} delay={i * 0.09}>
//                 <div className="home__why-card">
//                   <span className="home__why-icon">{w.icon}</span>
//                   <h3 className="home__why-title">{w.title}</h3>
//                   <p className="home__why-desc">{w.desc}</p>
//                 </div>
//               </AnimatedSection>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* ── Projects Preview ── */}
//       <section className="section" style={{ background: "#0d0d0d" }}>
//         <div className="container">
//           <AnimatedSection>
//             <div className="home__section-head">
//               <p className="section-label">OUR WORK</p>
//               <h2 className="section-title">FEATURED PROJECTS</h2>
//             </div>
//           </AnimatedSection>
//           <div className="grid-auto" style={{ gridTemplateColumns: "repeat(auto-fill,minmax(320px,1fr))" }}>
//             {PROJECTS.slice(0, 3).map((p, i) => (
//               <AnimatedSection key={p.id} delay={i * 0.1}>
//                 <ProjectCard project={p} />
//               </AnimatedSection>
//             ))}
//           </div>
//           <div style={{ textAlign: "center", marginTop: 44 }}>
//             <button className="btn-outline" onClick={() => navigate("/projects")}>VIEW ALL PROJECTS</button>
//           </div>
//         </div>
//       </section>

//     </div>
//   );
// }

// export default Home;




// import React from "react";
// import { useNavigate } from "react-router-dom";
// import { useTranslation } from "react-i18next"; // Add this import
// import AnimatedSection from "../../components/AnimatedSection/AnimatedSection";
// import ServiceCard from "../../components/ServiceCard/ServiceCard";
// import ProjectCard from "../../components/ProjectCard/ProjectCard";
// import homeData from "./homeData"; // Updated import
// import "./Home.css";

// function Home() {
//   const navigate = useNavigate();
//   const { i18n } = useTranslation(); // Add this
//   const currentLang = i18n.language; // Get current language
//   const data = homeData[currentLang] || homeData.en; // Fallback to English

//   return (
//     <div className="home">
//       {/* ── Hero ── */}
//       <section className="hero">
//         <img src={data.images.hero} alt="Industrial concrete floor polishing — SK Associate India" className="hero__bg" />
//         <div className="hero__overlay" />
//         <div className="hero__content">
//           <span className="hero__eyebrow">{data.hero.eyebrow}</span>
//           <h1 className="hero__h1">{data.hero.h1}</h1>
//           <h1 className="hero__h1 hero__h1--gold">{data.hero.h1Gold}</h1>
//           <p className="hero__sub">{data.hero.sub}</p>
//           <div className="hero__btns">
//             <button className="btn-primary" onClick={() => navigate("/services")}>{data.hero.btnExplore}</button>
//             <button className="btn-ghost" onClick={() => navigate("/contact")}>{data.hero.btnQuote}</button>
//           </div>
//         </div>
//         {/* Stats bar */}
//         <div className="hero__stats">
//           {data.stats.map((s) => (
//             <div key={s.label} className="hero__stat">
//               <span className="hero__stat-n">{s.number}</span>
//               <span className="hero__stat-l">{s.label}</span>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* ── About Preview ── */}
//       <section className="section home__about" style={{ background: "#111" }}>
//         <div className="container grid-2">
//           <AnimatedSection>
//             <div className="home__about-img-wrap">
//               <img src={data.images.warehouse} alt="SK Associate warehouse floor polishing team" className="home__about-img" />
//               <div className="home__about-badge">
//                 <span className="home__about-badge-n">{data.about.badgeN}</span>
//                 <span className="home__about-badge-l">{data.about.badgeL}</span>
//               </div>
//               <div className="home__about-thumb">
//                 <img src={data.images.team} alt="SK Associate expert team" />
//               </div>
//             </div>
//           </AnimatedSection>
//           <AnimatedSection delay={0.2}>
//             <p className="section-label">{data.about.label}</p>
//             <h2 className="section-title" style={{ marginBottom: 18 }}>{data.about.title}</h2>
//             <p className="home__body-text">{data.about.text1}</p>
//             <p className="home__body-text" style={{ marginBottom: 30 }}>{data.about.text2}</p>
//             <button className="btn-primary" onClick={() => navigate("/about")}>{data.about.btn}</button>
//           </AnimatedSection>
//         </div>
//       </section>

//       {/* ── Full-width Image Band ── */}
//       <div className="home__band">
//         <img src={data.images.factory} alt="SK Associate factory floor densification project" className="home__band-img" />
//         <div className="home__band-overlay" />
//         <div className="home__band-text">
//           <AnimatedSection>
//             <p className="section-label" style={{ textAlign: "center" }}>{data.band.label}</p>
//             <h2 className="home__band-title">{data.band.title}</h2>
//             <button className="btn-primary" onClick={() => navigate("/services")}>{data.band.btn}</button>
//           </AnimatedSection>
//         </div>
//       </div>

//       {/* ── Services Preview ── */}
//       <section className="section" style={{ background: "#0d0d0d" }}>
//         <div className="container">
//           <AnimatedSection>
//             <div className="home__section-head">
//               <p className="section-label">{data.services.label}</p>
//               <h2 className="section-title">{data.services.title}</h2>
//             </div>
//           </AnimatedSection>
//           <div className="grid-auto">
//             {data.servicesData.slice(0, 6).map((s, i) => (
//               <AnimatedSection key={s.id} delay={i * 0.07}>
//                 <ServiceCard service={s} />
//               </AnimatedSection>
//             ))}
//           </div>
//           <div style={{ textAlign: "center", marginTop: 44 }}>
//             <button className="btn-outline" onClick={() => navigate("/services")}>{data.services.btn}</button>
//           </div>
//         </div>
//       </section>

//       {/* ── 4-image gallery strip ── */}
//       <div className="home__gallery-strip">
//         {data.images.strip.map((src, i) => (
//           <div key={i} className="home__gallery-strip-cell">
//             <img src={src} alt={`SK Associate industrial floor project ${i + 1}`} />
//           </div>
//         ))}
//       </div>

//       {/* ── Why Choose Us ── */}
//       <section className="section" style={{ background: "#111" }}>
//         <div className="container">
//           <AnimatedSection>
//             <div className="home__section-head">
//               <p className="section-label">{data.whyUs.label}</p>
//               <h2 className="section-title">{data.whyUs.title}</h2>
//             </div>
//           </AnimatedSection>
//           <div className="grid-auto">
//             {data.whyUsData.map((w, i) => (
//               <AnimatedSection key={w.title} delay={i * 0.09}>
//                 <div className="home__why-card">
//                   <span className="home__why-icon">{w.icon}</span>
//                   <h3 className="home__why-title">{w.title}</h3>
//                   <p className="home__why-desc">{w.desc}</p>
//                 </div>
//               </AnimatedSection>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* ── Projects Preview ── */}
//       <section className="section" style={{ background: "#0d0d0d" }}>
//         <div className="container">
//           <AnimatedSection>
//             <div className="home__section-head">
//               <p className="section-label">{data.projects.label}</p>
//               <h2 className="section-title">{data.projects.title}</h2>
//             </div>
//           </AnimatedSection>
//           <div className="grid-auto" style={{ gridTemplateColumns: "repeat(auto-fill,minmax(320px,1fr))" }}>
//             {data.projectsData.slice(0, 3).map((p, i) => (
//               <AnimatedSection key={p.id} delay={i * 0.1}>
//                 <ProjectCard project={p} />
//               </AnimatedSection>
//             ))}
//           </div>
//           <div style={{ textAlign: "center", marginTop: 44 }}>
//             <button className="btn-outline" onClick={() => navigate("/projects")}>{data.projects.btn}</button>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// }

// export default Home;

import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AnimatedSection from "../../components/AnimatedSection/AnimatedSection";
import ServiceCard from "../../components/ServiceCard/ServiceCard";
import ProjectCard from "../../components/ProjectCard/ProjectCard";
import { SERVICES } from "../../data/services";
import { PROJECTS } from "../../data/projects";
import { STATS, WHY_US, IMAGES } from "../../data/constants";
import "./Home.css";

function Home() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="home">

      {/* ── Hero ── */}
      <section className="hero">
        <img src={IMAGES.hero} alt="Industrial concrete floor polishing — SK Associate India" className="hero__bg" />
        <div className="hero__overlay" />
        <div className="hero__content">
          <span className="hero__eyebrow">{t("hero.eyebrow")}</span>
          <h1 className="hero__h1">{t("hero.h1")}</h1>
          <h1 className="hero__h1 hero__h1--gold">{t("hero.h1_gold")}</h1>
          <p className="hero__sub">{t("hero.sub")}</p>
          <div className="hero__btns">
            <button className="btn-primary" onClick={() => navigate("/services")}>{t("hero.explore")}</button>
            <button className="btn-ghost"   onClick={() => navigate("/contact")}>{t("hero.quote")}</button>
          </div>
        </div>

        {/* Stats bar */}
        <div className="hero__stats">
          {STATS.map((s, i) => (
            <div key={s.label} className="hero__stat">
              <span className="hero__stat-n">{s.number}</span>
              <span className="hero__stat-l">{t(`stats_data.${i}`, s.label)}</span>
            </div>
          ))}
        </div>
      </section>

      {/* ── About Preview ── */}
      <section className="section home__about" style={{ background: "var(--bg2)" }}>
        <div className="container grid-2">
          <AnimatedSection>
            <div className="home__about-img-wrap">
              <img src={IMAGES.warehouse} alt="SK Associate warehouse floor polishing team" className="home__about-img" />
              <div className="home__about-badge">
                <span className="home__about-badge-n">{t("about_section.badge_years")}</span>
                <span className="home__about-badge-l">{t("about_section.badge_label")}</span>
              </div>
              <div className="home__about-thumb">
                <img src={IMAGES.team} alt="SK Associate expert team" />
              </div>
            </div>
          </AnimatedSection>
          <AnimatedSection delay={0.2}>
            <p className="section-label">{t("about_section.label")}</p>
            <h2 className="section-title" style={{ marginBottom: 18 }}>{t("about_section.title")}</h2>
            <p className="home__body-text">{t("about_section.body1")}</p>
            <p className="home__body-text" style={{ marginBottom: 30 }}>{t("about_section.body2")}</p>
            <button className="btn-primary" onClick={() => navigate("/about")}>{t("about_section.learn_more")}</button>
          </AnimatedSection>
        </div>
      </section>

      {/* ── Full-width Image Band ── */}
      <div className="home__band">
        <img src={IMAGES.factory} alt="SK Associate factory floor densification project" className="home__band-img" />
        <div className="home__band-overlay" />
        <div className="home__band-text">
          <AnimatedSection>
            <p className="section-label" style={{ textAlign: "center" }}>{t("band.label")}</p>
            <h2 className="home__band-title">{t("band.title")}</h2>
            <button className="btn-primary" onClick={() => navigate("/services")}>{t("band.cta")}</button>
          </AnimatedSection>
        </div>
      </div>

      {/* ── Services Preview ── */}
      <section className="section" style={{ background: "var(--bg)" }}>
        <div className="container">
          <AnimatedSection>
            <div className="home__section-head">
              <p className="section-label">{t("services_section.label")}</p>
              <h2 className="section-title">{t("services_section.title")}</h2>
            </div>
          </AnimatedSection>
          <div className="grid-auto">
            {SERVICES.slice(0, 6).map((s, i) => (
              <AnimatedSection key={s.id} delay={i * 0.07}>
                <ServiceCard service={s} />
              </AnimatedSection>
            ))}
          </div>
          <div style={{ textAlign: "center", marginTop: 44 }}>
            <button className="btn-outline" onClick={() => navigate("/services")}>{t("services_section.view_all")}</button>
          </div>
        </div>
      </section>

      {/* ── 4-image gallery strip ── */}
      <div className="home__gallery-strip">
        {IMAGES.strip.map((src, i) => (
          <div key={i} className="home__gallery-strip-cell">
            <img src={src} alt={`SK Associate industrial floor project ${i + 1}`} />
          </div>
        ))}
      </div>

      {/* ── Why Choose Us ── */}
      <section className="section" style={{ background: "var(--bg2)" }}>
        <div className="container">
          <AnimatedSection>
            <div className="home__section-head">
              <p className="section-label">{t("why_us.label")}</p>
              <h2 className="section-title">{t("why_us.title")}</h2>
            </div>
          </AnimatedSection>
          <div className="grid-auto">
            {WHY_US.map((w, i) => (
              <AnimatedSection key={w.title} delay={i * 0.09}>
                <div className="home__why-card">
                  <span className="home__why-icon">{w.icon}</span>
                  <h3 className="home__why-title">{t(`why_us_data.${i}.title`, w.title)}</h3>
                  <p className="home__why-desc">{t(`why_us_data.${i}.desc`, w.desc)}</p>
                </div>
              </AnimatedSection>
            ))}
          </div>
        </div>
      </section>

      {/* ── Projects Preview ── */}
      <section className="section" style={{ background: "var(--bg)" }}>
        <div className="container">
          <AnimatedSection>
            <div className="home__section-head">
              <p className="section-label">{t("projects_section.label")}</p>
              <h2 className="section-title">{t("projects_section.title")}</h2>
            </div>
          </AnimatedSection>
          <div className="grid-auto" style={{ gridTemplateColumns: "repeat(auto-fill,minmax(320px,1fr))" }}>
            {PROJECTS.slice(0, 3).map((p, i) => (
              <AnimatedSection key={p.id} delay={i * 0.1}>
                <ProjectCard project={p} />
              </AnimatedSection>
            ))}
          </div>
          <div style={{ textAlign: "center", marginTop: 44 }}>
            <button className="btn-outline" onClick={() => navigate("/projects")}>{t("projects_section.view_all")}</button>
          </div>
        </div>
      </section>

    </div>
  );
}

export default Home;